import {Col, DatePicker, Form, Input, InputNumber, Row, Select} from 'antd';
import React from 'react';
import {Arguments} from '../common/Arguments';
import AddFormComponent from '../common/AddFormComponent';
import EditFormComponent from '../common/EditFormComponent';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const {TextArea} = Input;

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const AddSocietyInformation = () => {
	const currentUrl = window.location.href;
	const apiList = [Arguments.host + '/society_organization/society/api!addSocietyInformation.do'];

	return (currentUrl.endsWith('add') ? <AddFormComponent UserForm={SocietyInformationForm} url={apiList}/> :
		<EditFormComponent UserForm={SocietyInformationForm} url={apiList}/>);
};
const SocietyInformationForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="organizationName"
						label="组织名称"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="organizationType" label="组织类型"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="社会团体">
						<Select>
							<Select.Option value="社会团体">社会团体</Select.Option>
							<Select.Option value="社会服务机构">社会服务机构</Select.Option>
							<Select.Option value="基金会">基金会</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="organizationCode"
						label="组织机构代码"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="establishUnit"
						label="发起人/单位"
						rules={[{required: true, message: '内容不能为空'}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="organizationEstablishDate" label="成立日期"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="organizationEstablishMoney" label="开办资金（万元）"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="organizationBank" label="开户行名称"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="organizationBankAccount" label="开户行账号"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="organizationEvaluationGrade" label="评估等级"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="无">
						<Select>
							<Select.Option value="无">无</Select.Option>
							<Select.Option value="1A">1A</Select.Option>
							<Select.Option value="2A">2A</Select.Option>
							<Select.Option value="3A">3A</Select.Option>
							<Select.Option value="4A">4A</Select.Option>
							<Select.Option value="5A">5A</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="organizationPublicWx" label="公众号">
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="organizationSubdiscipline"
						label="学科类别"
						rules={[{required: true, message: '内容不能为空'}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="organizationWorkPeopleCount"
						label="从业人数"
						rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
			</Row>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="organizationMemo"
						label="学会简介"
						rules={[{required: true, message: '内容不能为空'}]}>
						<TextArea rows={6} placeholder="请输入学会的简单介绍内容"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="organizationOneTermYear" label="每届年限"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="5">
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="organizationCurrentTerm" label="当前届数"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="1">
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="organizationTermDate"
						label="换届日期"
						rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="status" label="当前状态"
						rules={[{required: true, message: '内容不能为空'}]}
						initialValue="正常">
						<Select>
							<Select.Option value="正常">正常</Select.Option>
							<Select.Option value="注销">注销</Select.Option>
							<Select.Option value="撤销">撤销</Select.Option>
							<Select.Option value="转出">转出</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="showFlag"
						label="显示序号"
						rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="stOrMbsk"
						label="类别"
						rules={[{required: true, message: '内容不能为空'}]}
						initialValue="社团">
						<Select>
							<Select.Option value="社团">社团</Select.Option>
							<Select.Option value="民非">民非</Select.Option>
							<Select.Option value="基金会">基金会</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddSocietyInformation;
